// extracted by mini-css-extract-plugin
module.exports = {"post":"post-module__post___18Q40","wrap":"post-module__wrap___2oMVQ","content":"post-module__content___366dU"};